module.exports = __webpack_public_path__ + "static/second-image-402d07920f50df45e6f5f7e83f936d7e.png";